module.exports = __webpack_public_path__ + "img/banner_cfr_pve.43da98f9.png";